export const LANGS = ['es', 'it', 'fr', 'de', 'en']
export const LANG_NAMES = {
  es: 'Spanish',
  it: 'Italian',
  de: 'German',
  fr: 'French',
  en: 'English',
}

export const SITES_INFO = {
  'vinissimus.com': {
    shop: 'vinissimus',
    lang: 'es',
    country: 'es',
  },
  'vinissimus.co.uk': {
    shop: 'uk',
    lang: 'en',
    country: 'uk',
  },
  'vinissimus.fr': {
    shop: 'vinissimus',
    lang: 'fr',
    country: 'fr',
  },
  'hispavinus.de': {
    shop: 'de',
    lang: 'de',
    country: 'de',
  },
  'italvinus.it': {
    shop: 'italvinus',
    lang: 'it',
    country: 'it',
  },
}

export const SITES = Object.keys(SITES_INFO)

export const SHOPS = Object.values(SITES_INFO).map(({ shop }) => shop)

// export const TINYMCE_APIKEY = 'g1pc6d1ox3x0odwrdl2odk4fsxnn6d9dm6jhtjp9gsyli505'
export const TINYMCE_APIKEY = 'z7t65ku7as9m9oumznpl1tua2c0n39rtpdjg9wjlh3cosldo'
export const TINYMCE_INIT_UNRESTRICTED = {
  height: 500,
  width: '100%',
  menubar: false,
  // The following line is needed to preserve absolute urls like
  //   '/es/content/vinos-ecologicos-y-biodinamicos/...'
  relative_urls: false,
  // plugins: [
  //   'advlist autolink lists link image charmap print preview anchor',
  //   'searchreplace visualblocks code fullscreen',
  //   'insertdatetime media table paste code help wordcount'
  // ],
  plugins: ['link paste code lists table image media'],
  toolbar:
    'undo redo | formatselect | bold italic | numlist bullist | link | removeformat ' +
    ' | code | table | image | media',
  block_formats: 'Paragraph=p; Header 2=h2; Header 3=h3; Header 4=h4',
}
export const TINYMCE_INIT = {
  ...TINYMCE_INIT_UNRESTRICTED,
  valid_elements:
    '@[id|title],a[rel|rev|charset|hreflang|tabindex|accesskey|type|' +
    'name|href|target|title|class],strong/b,em/i,strike,u,' +
    '#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|' +
    'src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,' +
    '-blockquote,-div,-span,-code,-pre,-h2,-h3,-h4,hr[size|noshade]' +
    '-blockquote,-table[border=0|cellspacing|cellpadding|width|frame|rules|' +
    'height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|' +
    'height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,' +
    '#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor' +
    '|scope],#th[colspan|rowspan|width|height|align|valign|scope]' +
    'iframe[align<bottom?left?middle?right?top|class|frameborder|height|id' +
    '|longdesc|marginheight|marginwidth|name|scrolling<auto?no?yes|src|style' +
    '|title|width]',
}

export const MEDIA_URL_stage = 'https://stage.vinissimus.com/images/'
export const CDN_URL_stage =
  'https://stage-cdn.vinissimus.com/img/unsafe/keep/plain/local:///'
export const MEDIA_URL_prod = 'https://www.vinissimus.com/images/'
export const CDN_URL_prod =
  'https://cdn.vinissimus.com/img/unsafe/keep/plain/local:///'

export const isProd = () => {
  const u = new URL(window.location.href)
  return u.hostname.startsWith('www')
}

export const getMediaUrl = () => {
  if (isProd()) {
    return MEDIA_URL_prod
  }
  return MEDIA_URL_stage
}

export const getCdnUrl = () => {
  if (isProd()) {
    return CDN_URL_prod
  }
  return CDN_URL_stage
}

export function setLangs(t) {
  return LANGS.reduce((o, lang) => {
    o[lang] = t
    return o
  }, {})
}

export const frontThemes = [
  'clear',
  'clear-grey-green',
  'clear-pink',
  'dark',
  'golden',
  'grey-green',
  'light',
  'light-blue',
  'light-green',
  'light-grey-green',
  'light-orange',
  'light-pink',
  'light-purple',
  'light-shine',
  'orange',
  'pink',
  'shine',
]

const emptyStringLangs = setLangs('')

const imageHome = {
  buttonText: emptyStringLangs,
  buttonTheme: 'primary',
  filter: undefined, // dark, clear
  height: 250,
  href: emptyStringLangs,
  id: 'image',
  image: emptyStringLangs,
  imageCover: true,
  imageRepeat: false,
  removePadding: false,
  textBanner: emptyStringLangs,
  textBigger: false,
  theme: 'clear',
  title: emptyStringLangs,
  widthSize: 'regular',
}

export const homeSectionsToAdd = [
  {
    id: 'special',
    buttonText: emptyStringLangs,
    title: {
      es: 'Especial',
      fr: 'Spécial',
      de: 'Spezial',
      en: 'Special',
      it: 'Speciale',
    },
    type: 'Grid8Small',
    theme: 'grey-green',
    query: {},
  },
  {
    id: 'product-banner',
    bgColor: '#ffe8c5',
  },
  imageHome,
  {
    ...imageHome,
    id: 'image-slider',
    images: emptyStringLangs,
  },
  {
    ...imageHome,
    id: 'product-image',
    widthSize: 'big',
    query: {},
  },
  {
    id: 'html',
    html: emptyStringLangs,
  },
  {
    id: 'offer-banner',
    query: {},
    discount: 15,
    image: emptyStringLangs,
    title: emptyStringLangs,
    discount_text: emptyStringLangs,
    is_same_offer_for_all_products: true,
    link: emptyStringLangs,
    text_banner: emptyStringLangs,
  },
  {
    id: 'blog-posts',
    posts_ids: setLangs([]),
  },
]

export const defaultHomeSections = [
  {
    id: 'trust-elements',
  },
  {
    id: 'bestsellers',
    title: {
      es: 'Los más vendidos del mes',
      de: 'Top-Verkäufe des Monats',
      en: "This month's Best Sellers",
      fr: 'Les plus vendus du mois',
      it: 'I più venduti del mese',
    },
    type: 'Catalog',
    theme: 'clear-grey-green',
  },
  {
    id: 'mini-banners',
  },
  {
    id: 'news',
    buttonText: {
      es: 'Más novedades',
      de: 'Mehr Neuheiten',
      en: 'More new wines',
      fr: 'Plus de nouveautés',
      it: 'Altre novità',
    },
    title: {
      es: 'Novedades',
      de: 'Neuheiten',
      en: 'New additions',
      fr: 'Nouveautés',
      it: 'Novità',
    },
    type: 'Catalog',
    theme: 'clear',
  },
  {
    id: 'offer-and-promo',
    buttonText: {
      es: 'Más ofertas y promociones',
      de: 'Mehr Angebote',
      en: 'More special offers',
      fr: "Plus d'offres et promotions",
      it: 'Altre offerte e promozioni',
    },
    title: {
      es: 'Ofertas',
      de: 'Angebote',
      en: 'Special offers',
      fr: 'Offres',
      it: 'Offerte',
    },
    type: 'Catalog',
    theme: 'golden',
  },
  {
    id: 'recomendations',
    title: {
      es: 'Recomendaciones para usted',
      de: 'Empfehlungen für Sie',
      en: 'Our recommendations for you',
      fr: 'Nos recommandations pour vous',
      it: 'Le nostre raccomandazioni',
    },
    type: 'Carousel',
    theme: 'light',
  },
]

export const buttonThemes = [
  'primary',
  'default',
  'btn-as-link',
  'btn-black',
  'btn-white',
]

// Keep in sync with the country selector on www.vinissimus.com:
// checkout /@constants countries filtered by frontend allowedCountries.
export const ALL_COUNTRIES = {
  an: 'Andorra',
  at: 'Austria',
  be: 'Belgium',
  bg: 'Bulgaria',
  ch: 'Switzerland',
  cz: 'Czech Republic',
  de: 'Germany',
  dk: 'Denmark',
  ee: 'Estonia',
  es: 'Spain',
  fr: 'France',
  ho: 'Netherlands',
  hr: 'Croatia',
  hu: 'Hungary',
  it: 'Italy',
  li: 'Lithuania',
  lu: 'Luxembourg',
  lv: 'Latvia',
  pl: 'Poland',
  po: 'Portugal',
  ro: 'Romania',
  sk: 'Slovakia',
  sl: 'Slovenia',
  uk: 'United Kingdom',
}

export const SELLING_COUNTRIES = [
  'an',
  'at',
  'be',
  'bg',
  'ch',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fr',
  'ho',
  'hr',
  'hu',
  'it',
  'li',
  'lu',
  'lv',
  'pl',
  'po',
  'ro',
  'sk',
  'sl',
  'uk',
]

export const DISTANCE_SELLING = {
  fr: 'France',
  de: 'Germany',
  at: 'Austria',
  be: 'Belgium',
  ho: 'Netherlands',
  po: 'Portugal',
  se: 'Sweden',
  it: 'Italy',
}

export const COUNTRIES = Object.keys(ALL_COUNTRIES)

export const capacityNames = {
  b3: 'Bag in box 3L',
  b5: 'Bag in box 5L',
  dc: 'Balthazar',
  dm: 'Doble Magnum',
  ma: 'Magnum',
  mt: 'Imperial',
  na: 'Nabuchodonosor',
  pr: 'Primat',
  sa: 'Melchior',
  sz: 'Salmanazar',
}

export const BOTTLE_CAPACITY_LITERS = {
  10: 0.1,
  17: 1.75,
  20: 0.2,
  25: 2.5,
  33: 0.33,
  35: 0.35,
  37: 0.37,
  50: 0.5,
  62: 0.62,
  65: 0.65,
  70: 0.7,
  72: 0.72,
  75: 0.75,
  b3: 3.0, // Bag in box 3L
  b5: 5.0, // Bag in box 5L
  b2: 20.0, // Bag in box 20L
  cu: 0.025,
  dc: 12.0, // Balthazar
  dm: 3.0, // Doble Magnum
  je: 5.0,
  li: 1.0,
  ma: 1.5, // Magnum
  mt: 6.0, // Imperial
  na: 15.0, // Nabuchodonosor
  pr: 27.0, // Primat
  sa: 18.0, // Melchior
  sz: 9.0, // Salmanazar
}

export const catalogs = [
  'Carousel',
  'CarouselSmall',
  'Catalog',
  'CatalogSmall',
  'Grid12',
  'Grid12Small',
  'Grid8',
  'Grid8Small',
]

export const FREE_SHIPPING_RATES = {
  dtp: 'Descuento transporte producto',
  trd: 'Transporte con descuento',
  trg: 'Transporte gratis',
}
